import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import InputWrapper from 'components/custom/InputWrapper'
import Select from 'react-select';

import styles from './styles.scss'

import { 
    projectListDropdownSelector,
    projectSelectedSelector
} from 'containers/Form/Project/selectors'

import {     
    fetchProjectList,
    setProjectSelected
} from 'containers/Form/Project/actions'


const mapStateToProps = (state) => {
    return {
      projectListDropdown: projectListDropdownSelector(state),
      projectSelected: projectSelectedSelector(state)
    }
  }
  
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProjectList: (query) => dispatch(fetchProjectList(query)),
        setProjectSelected: (projectId) => dispatch(setProjectSelected(projectId))
    }
}

const InitPage = ({
    projectListDropdown,
    projectSelected,
    fetchProjectList,
    setProjectSelected
}) => {

    return (
        <Fragment>
            <InputWrapper label={"Project"}>
                <Select
                    placeholder={"Begin by typing the project ID or name..."}
                    options={projectListDropdown}
                    onInputChange={fetchProjectList}
                    value={projectSelected}
                    onChange={setProjectSelected}
                    noResultsText={'Type something, or try a different query'}
                />
            </InputWrapper>
        </Fragment>
    )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const styledComponent = CSSModules(InitPage, styles)
export default withConnect(styledComponent)
